module.exports = __webpack_public_path__ + "static/media/SWSCRC6-41.c3caec42.mp3";